// extracted by mini-css-extract-plugin
export default {"commandsPanel":"GoodsClassifierItemsPluginView_commandsPanel__FwhBe","toolBarWrapper":"GoodsClassifierItemsPluginView_toolBarWrapper__A1qkH"};